// const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    name: 'crm_selectPharmacy',
    component: () => import(/* webpackChunkName: "crm_selectPharmacy" */ '@/pages/crm/selectPharmacy.vue'),
    meta: {
      title: '选择客户'
    },
    path: '/crm_selectPharmacy/:token'
  }
];
